/**
 * Explore on your own (spec 33 section 6.6): the things worth trying in a
 * demo fleet once the walkthroughs have shown the way, ticked the first time
 * the visitor actually goes there. A checklist whose truth is where the
 * visitor went, never what they clicked in a list (Appcues' rule: items tick
 * from the real event).
 *
 * Pure: route names in, ids out. The walkthrough menu keeps the ticks
 * (persistence.js markExplored) and renders the list.
 */
export const EXPLORE_ITEMS = Object.freeze([
  {
    id: 'pod',
    label: "Open a delivered load's proof of delivery",
    to: { name: 'Dispatch', query: { tab: 'delivered' } },
    // Any load page counts once the visitor has been looking at delivered work.
    routes: ['LoadsView'],
  },
  {
    id: 'map',
    label: 'Watch the truck that is moving',
    to: { name: 'Tracking' },
    routes: ['Tracking'],
  },
  {
    id: 'pay',
    label: 'See what a subhauler is owed',
    // The pay report is a Settlements tab now (2026-10-10); /drivers/report
    // redirects there, so the visited route is Settlements.
    to: { name: 'Settlements', query: { tab: 'pay-report' } },
    routes: ['Settlements'],
  },
  {
    id: 'ifta',
    label: 'Read the IFTA miles report',
    to: { name: 'IftaReport' },
    routes: ['IftaReport'],
  },
  {
    id: 'accounting',
    label: 'Look at the accounting connection',
    to: { name: 'Integrations' },
    routes: ['Integrations'],
  },
  {
    id: 'template',
    label: 'Open a document template',
    to: { name: 'Documents', query: { tab: 'templates' } },
    routes: ['DocumentSendFromTemplate', 'DocumentSend', 'DocumentTemplateDesign'],
  },
]);

/** The explore items a visit to the route named `routeName` ticks. */
export function itemsVisitedBy(routeName) {
  if (!routeName) return [];
  return EXPLORE_ITEMS.filter(item => item.routes.includes(routeName)).map(item => item.id);
}
